import styled from '@emotion/styled';

export const StyledTextArea = styled.textarea`
  border: none;
  width: 100%;
  min-height: 30px;
  padding: 0;
  color: ${({ theme }) => theme.palette.colors.primary};
  font-size: ${({ theme }) => theme.fontSizes.f3};
  line-height: ${({ theme }) => theme.lineHeights.xl};
  font-weight: ${({ theme }) => theme.fontWeights.normal};
  font-family: ${({ theme }) => theme.fontFamilies.body};
  resize: vertical;

  &:focus {
    outline: none;
  }

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  &[type='number'] {
    -moz-appearance: textfield;
  }
`;
